import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-9da281b8"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "notesComponent"
};
var _hoisted_2 = {
  "class": "notesComponent__title"
};
var _hoisted_3 = {
  "class": "notesComponent__list"
};
var _hoisted_4 = ["onClick"];
var _hoisted_5 = {
  key: 0,
  "class": "notesComponent__draft--line"
};
var _hoisted_6 = {
  "class": "notesComponent__list-item-actions"
};
var _hoisted_7 = {
  key: 1,
  "class": "notesComponent__content"
};
var _hoisted_8 = {
  "class": "notesComponent__content-actions"
};
var _hoisted_9 = {
  key: 0,
  "class": "notesComponent__draft"
};
var _hoisted_10 = ["onClick"];
var _hoisted_11 = ["onUpdate:modelValue", "disabled", "onChange"];
var _hoisted_12 = ["disabled", "onUpdate:modelValue", "onChange"];
var _hoisted_13 = ["onClick"];
var _hoisted_14 = {
  key: 0,
  "class": "notesComponent__add"
};
var _hoisted_15 = {
  key: 0
};
var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h1", null, "What type of note would you like to add?", -1);
});
var _hoisted_17 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  var _component_ButtonBasic = _resolveComponent("ButtonBasic");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createTextVNode("My Notes "), _createVNode(_component_font_awesome_icon, {
    icon: "fa-times",
    "class": "closeNotes",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      _ctx.$store.commit('updateShowNotes', false);
    })
  })]), _createElementVNode("ul", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.notes, function (Note, index) {
    return _openBlock(), _createElementBlock("li", {
      "class": "notesComponent__list-item",
      key: index,
      onClick: function onClick($event) {
        !Note.show ? _ctx.$store.commit('toggleShowNote', index) : null;
      }
    }, [_createElementVNode("span", null, _toDisplayString(Note.title), 1), Note.hasEdits ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Draft")) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_6, [_createVNode(_component_font_awesome_icon, {
      onClick: function onClick($event) {
        return !Note.show ? $options.deleteNote(index) : null;
      },
      icon: "fa-trash-alt",
      "class": "fas fa-phone notesComponent__icon-trash"
    }, null, 8, ["onClick"])]), Note.show ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createTextVNode(_toDisplayString($options.loadContent(Note)) + " ", 1), Note.hasEdits ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Draft! Changes will be lost if app is closed!")) : _createCommentVNode("", true), _createElementVNode("div", {
      "class": "notesComponent__content-back",
      onClick: function onClick($event) {
        _ctx.$store.commit('closeNote', index);
      }
    }, [_createVNode(_component_font_awesome_icon, {
      icon: "fa-times",
      "class": "fas fa-phone notesComponent__icon-back"
    }), _createTextVNode(" Close")], 8, _hoisted_10), _createVNode(_component_font_awesome_icon, {
      onClick: function onClick($event) {
        _ctx.$store.commit('editNote', index);
      },
      icon: "fa-edit",
      "class": "fas fa-phone notesComponent__content-icon notesComponent__content-icon-left"
    }, null, 8, ["onClick"]), _createVNode(_component_font_awesome_icon, {
      onClick: function onClick($event) {
        return $options.deleteNote(index);
      },
      icon: "fa-trash-alt",
      "class": "fas fa-phone notesComponent__content-icon"
    }, null, 8, ["onClick"])]), _withDirectives(_createElementVNode("input", {
      "class": "notesComponent__content-title",
      "onUpdate:modelValue": function onUpdateModelValue($event) {
        return Note.title = $event;
      },
      disabled: !Note.editing,
      onChange: function onChange($event) {
        return Note.hasEdits = true;
      }
    }, null, 40, _hoisted_11), [[_vModelText, Note.title]]), _withDirectives(_createElementVNode("textarea", {
      "class": "notesComponent__content-text",
      disabled: !Note.editing,
      "onUpdate:modelValue": function onUpdateModelValue($event) {
        return Note.text = $event;
      },
      onChange: function onChange($event) {
        return Note.hasEdits = true;
      }
    }, null, 40, _hoisted_12), [[_vModelText, Note.text]]), Note.editing || Note.hasEdits ? (_openBlock(), _createElementBlock("button", {
      key: 0,
      "class": "notesComponent__content-button",
      onClick: function onClick($event) {
        return $options.saveNoteEdit(Note);
      }
    }, "Save", 8, _hoisted_13)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 8, _hoisted_4);
  }), 128))]), $data.showAddNote ? (_openBlock(), _createElementBlock("div", _hoisted_14, [!$data.noteType ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_hoisted_16, _createElementVNode("button", {
    onClick: _cache[1] || (_cache[1] = function ($event) {
      $data.noteType = 'text';
    }),
    "class": "select_type_button"
  }, [_createVNode(_component_font_awesome_icon, {
    icon: "fa-keyboard",
    "class": _normalizeClass({
      'type__icon': true
    })
  }), _createTextVNode(" Text Note")]), _createElementVNode("button", {
    onClick: _cache[2] || (_cache[2] = function ($event) {
      $data.noteType = 'sketch';
      _ctx.$store.commit('updateShowDrawingPad', true);
      $data.noteType = null;
      $data.showAddNote = false;
    }),
    "class": "select_type_button"
  }, [_createVNode(_component_font_awesome_icon, {
    icon: "fa-pencil",
    "class": _normalizeClass({
      'type__icon': true
    })
  }), _createTextVNode(" Sketch")])])) : _createCommentVNode("", true), $data.noteType === 'text' ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("div", {
    "class": "notesComponent__content-back",
    onClick: _cache[3] || (_cache[3] = function ($event) {
      $data.showAddNote = false;
    })
  }, [_createVNode(_component_font_awesome_icon, {
    icon: "fa-chevron-left",
    "class": "fas fa-phone notesComponent__icon-back"
  }), _createTextVNode(" Back")]), _withDirectives(_createElementVNode("input", {
    "class": "notesComponent__input",
    type: "text",
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return $data.noteTitle = $event;
    }),
    placeholder: "Add Note Title"
  }, null, 512), [[_vModelText, $data.noteTitle]]), _withDirectives(_createElementVNode("textarea", {
    "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
      return $data.noteText = $event;
    }),
    "class": "notesComponent__input-area",
    placeholder: "Add Note Content"
  }, null, 512), [[_vModelText, $data.noteText]]), $data.showAddNote ? (_openBlock(), _createBlock(_component_ButtonBasic, {
    key: 0,
    label: "Save Note",
    "class": "notesComponent__save-button",
    style: {
      "z-index": "99999999"
    },
    onClick: _cache[6] || (_cache[6] = function ($event) {
      $data.noteType = null;
      $options.addNote();
    })
  })) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createVNode(_component_ButtonBasic, {
    "class": "notesComponent__button",
    onClick: _cache[8] || (_cache[8] = function ($event) {
      return $options.toggleShowAddNote();
    })
  }, {
    "default": _withCtx(function () {
      return [_createTextVNode("Add New Note "), _createVNode(_component_font_awesome_icon, {
        onClick: _cache[7] || (_cache[7] = function ($event) {
          return $options.toggleShowAddNote();
        }),
        icon: "fa-plus"
      })];
    }),
    _: 1
  })]);
}